import React from 'react';
import * as Ant from 'antd';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as CatUtil from '../../Utils/CatUtil';

export default function FilterSection(props) {
  const {collection, categories_key, filters, setFilters} = props;

  const options = React.useMemo(() => {
    if (collection === 'health_education') {
      const cats = CatUtil.getCategories(categories_key);

      const cat = cats.find((c) => c.name === filters.category);
      if (cat) {
        return cat.items;
      }
    }
    return [];
  }, [collection, categories_key, filters]);
  return (
    <Wrapper>
      <div className="row">
        {collection === 'health_education' ? (
          <div
            style={{
              width: '100%',
              padding: 8,
              backgroundColor: '#f1f1f1',
              display: 'flex',
            }}>
            <Ant.Select
              value={filters.sub_category}
              style={{width: 200, marginRight: 10}}
              onChange={(value) =>
                setFilters((prev) => ({
                  ...prev,
                  sub_category: value,
                }))
              }
              placeholder="全部類別">
              <Ant.Select.Option value={''}>全部類別</Ant.Select.Option>
              {options.map((o) => (
                <Ant.Select.Option key={o.name} value={o.name}>
                  {o.display}
                </Ant.Select.Option>
              ))}
            </Ant.Select>
            <Ant.Input.Search
              allowClear
              onSearch={(value) =>
                setFilters((prev) => ({
                  ...prev,
                  title: value ? {$regex: value} : undefined,
                }))
              }
              placeholder="關鍵字"
            />
          </div>
        ) : collection === 'Article_Default' ? (
          <div style={{padding: 8, backgroundColor: '#f1f1f1', width: '100%'}}>
            <Ant.Input.Search
              allowClear
              onSearch={(value) =>
                setFilters((prev) => ({
                  ...prev,
                  title: value ? {$regex: value} : undefined,
                }))
              }
              placeholder="關鍵字"
            />
          </div>
        ) : null}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  .row {
    display: flex;
    align-items: center;
  }
`;
